<template>
    <div>
        <CCol sm="12">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
    
                <CCard class="p-2" style="border:none;">
                    <CRow class="m-2">
                        <CCol sm="12" md="4" lg="3" class="text-center p-2" v-for="button in buttons" :key="button.value">
                            <div :class="{'blue-background': activeButton === button.value, 'blue-text': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2">
                                <img style="max-width:20px" class="mr-2" /> {{ button.label }}
                            </div>
                        </CCol>
                        <!-- <CCol sm="6">
                            <CButton class="btn-border-blue font-color-0B63F6 float-right" @click="openCreate"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Run Payment</CButton>
                        </CCol> -->
                        
                    </CRow>
                    <CRow>
                        
                    </CRow>
                </CCard>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div v-if="activeButton === 'paymentVoucherList'">
                        <CCol sm="12" md="4" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="7"><span>filter</span>
                                        <select v-model="perPage" id="entries" class="form-control">
                                                            <option :value="10">10</option>
                                                            <option :value="25">25</option>
                                                            <option :value="50">50</option>
                                                            <option :value="100">100</option>
                                                        </select>
                                    </CCol>
                                    <CCol sm="5" class="mt-3">
                                        <CButton class="btn-border-blue font-color-0B63F6 float-right" @click="openCreate"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Run Payment</CButton>
                                    </CCol>
                                </CRow>
                            </div>
                        </CCol>
                        
    
                            <v-client-table :data="allTableData" :columns="columns" :options="options" class="custom-table" v-if="allTableData.length > 0">
                            <template v-slot:No="{ row }">
                                                      <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Title="{ row }">
    <label class="custom-12px-500">{{ row.Title }}</label>
</template>

<template v-slot:Status="{ row }">
    <label class="custom-12px-500 bg-FEF3F2 font-color-B42318">{{ row.Status }}</label>
</template>

<template v-slot:Announcer="{ row }">
    <label class="custom-12px-500">{{ row.Status }}</label>
</template>

<template v-slot:Created Date="{ row }">
    <label class="custom-12px-500">{{ row.CreatedDate }}</label>
</template>

<template v-slot:Updated Date="{ row }">
    <label class="custom-12px-500">{{ row.UpdatedDate }}</label>
</template>

<template v-slot:Action="{ row }">
    <div class="d-flex"> 
        <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="openEdit(row.Index)" class="ml-2" />
        <img :src="require('@/assets/img/doc.png')" alt="Print" style="cursor: pointer;width:30px" @click="download(row.Index)"class="ml-2" />
                                                
    </div>
</template>
                            </v-client-table>
                            <div v-else class="no-data-message text-center" style="margin:10%">
                    <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
                    <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                    <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                    </div>
            </div>


            <div v-if="activeButton === 'task'">
                <CCol sm="12" md="4" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="7"><span>filter</span>
                                        <select v-model="perPage" id="entries" class="form-control">
                                                            <option :value="10">10</option>
                                                            <option :value="25">25</option>
                                                            <option :value="50">50</option>
                                                            <option :value="100">100</option>
                                                        </select>
                                    </CCol>
                                    <CCol sm="5" class="mt-3">
                                        <CButton class="btn-border-blue font-color-0B63F6 float-right" @click="openCreate"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Run Payment</CButton>
                                    </CCol>
                                </CRow>
                            </div>
                        </CCol>
                        
    
                            <v-client-table :data="allTableData" :columns="columns" :options="options" class="custom-table" v-if="allTableData.length > 0">
                            <template v-slot:No="{ row }">
                                                      <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Title="{ row }">
    <label class="custom-12px-500">{{ row.Title }}</label>
</template>

<template v-slot:Status="{ row }">
    <label class="custom-12px-500 bg-FEF3F2 font-color-B42318">{{ row.Status }}</label>
</template>

<template v-slot:Announcer="{ row }">
    <label class="custom-12px-500">{{ row.Status }}</label>
</template>

<template v-slot:Created Date="{ row }">
    <label class="custom-12px-500">{{ row.CreatedDate }}</label>
</template>

<template v-slot:Updated Date="{ row }">
    <label class="custom-12px-500">{{ row.UpdatedDate }}</label>
</template>

<template v-slot:Action="{ row }">
    <div class="d-flex"> 
        <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:20px" @click="viewRow(row.Index)" class="ml-2" />
        <img :src="require('@/assets/img/doc.png')" alt="Print" style="cursor: pointer;width:20px" @click="openEdit(row.Index)"class="ml-2" />
                                                
    </div>
</template>
                            </v-client-table>
                            <div v-else class="no-data-message text-center" style="margin:10%">
                    <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
                    <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                    <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                    </div>
            </div>

            <div v-if="activeButton === 'report'">
                <CCol sm="12" md="4" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="7"><span>filter</span>
                                        <select v-model="perPage" id="entries" class="form-control">
                                                            <option :value="10">10</option>
                                                            <option :value="25">25</option>
                                                            <option :value="50">50</option>
                                                            <option :value="100">100</option>
                                                        </select>
                                    </CCol>
                                    <CCol sm="5" class="mt-3">
                                        <CButton class="btn-border-blue font-color-0B63F6 float-right" @click="openCreate"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Run Payment</CButton>
                                    </CCol>
                                </CRow>
                            </div>
                        </CCol>
                        
    
                            <v-client-table :data="allTableData" :columns="columns" :options="options" class="custom-table" v-if="allTableData.length > 0">
                            <template v-slot:No="{ row }">
                                                      <label class="custom-12px-500">{{ row.No }}</label>
</template>

<template v-slot:Title="{ row }">
    <label class="custom-12px-500">{{ row.Title }}</label>
</template>

<template v-slot:Status="{ row }">
    <label class="custom-12px-500 bg-FEF3F2 font-color-B42318">{{ row.Status }}</label>
</template>

<template v-slot:Announcer="{ row }">
    <label class="custom-12px-500">{{ row.Status }}</label>
</template>

<template v-slot:Created Date="{ row }">
    <label class="custom-12px-500">{{ row.CreatedDate }}</label>
</template>

<template v-slot:Updated Date="{ row }">
    <label class="custom-12px-500">{{ row.UpdatedDate }}</label>
</template>

<template v-slot:Action="{ row }">
    <div class="d-flex"> 
        <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:20px" @click="viewRow(row.Index)" class="ml-2" />
        <img :src="require('@/assets/img/doc.png')" alt="Print" style="cursor: pointer;width:20px" @click="openEdit(row.Index)"class="ml-2" />
                                                
    </div>
</template>
                            </v-client-table>
                            <div v-else class="no-data-message text-center" style="margin:10%">
                    <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;"/>
                    <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                    <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                    </div>
            </div>
                   

                </CCard>
            </CCol>
    
        </CCol>
        <div v-if="OpenCreate" class="popup-all backdrop-all">
            <div class="popup-all1">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Run New Voucher</h3>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupCreate" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Paument Voucher No</h3>
                                        <CInput type="text" v-model="FullName" />
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Year</h3>
                                        <CInput type="text" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Month</h3>
                                        <CInput type="text" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Payment Date</h3>
                                        <CInput type="date" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px-500 font-color-171717">Remarks</h3>
                                        <CTextarea type="text" v-model="ShortName" />
                                    </CCol>
                                    <CCol sm="6">
                                        <CRow>
                                            <h3 class="custom-14px-500 font-color-171717">Claim Financial</h3>
                                            <CSwitch class="ml-3" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                        </CRow>
                                    </CCol>
                                    <CCol sm="6">
                                        <CRow>
                                            <h3 class="custom-14px-500 font-color-171717">Overtime Financial</h3>
                                            <CSwitch class="ml-3" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/>
                                        </CRow>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <div class="text-right mt-2">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitCompany">
                                Generate</CButton>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
        <div v-if="OpenEdit" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="2">
                        <img src="../assets/img/round-calendar.png" style="max-width:60px"/>
                    </CCol>
                    <CCol sm="8">
                        <h3 class="custom-14px-500 font-color-171717">August 2024</h3>
                        <h3 class="font-color-98A2B3" style="font-size: 12px;font-weight: 400; color: #98A2B3;">14 August 2024</h3>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupEdit" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="5">
                                        <h3 class="custom-16px-500 bg-E0EAFF font-color-003CC5">Payment Voucher</h3>
                                        <CCol sm="12">
                                            <CRow>
                                                <CCol sm="3">
                                                    <CRow>
                                                        <CCol sm="12" class="mt-3">
                                                            <img src="../assets/img/menu-tab.png" style="max-width:45px;"/>
                                                        </CCol>
                                                        <CCol sm="12" class="ml-3">
                                                            <img src="../assets/img/line-menu.png" style="max-width:40px; height: 35px;"/>
                                                        </CCol>
                                                        <CCol sm="12">
                                                            <img src="../assets/img/menu-tab.png" style="max-width:45px;"/>
                                                        </CCol>
                                                        <CCol sm="12" class="ml-3">
                                                            <img src="../assets/img/line-menu.png" style="max-width:40px; height: 35px;"/>
                                                        </CCol>
                                                        <CCol sm="12">
                                                            <img src="../assets/img/menu-tab.png" style="max-width:45px;"/>
                                                        </CCol>
                                                    </CRow>
                                                </CCol>
                                                <CCol sm="9">
                                                    <CCol sm="12" class="mt-3">
                                                        <h3 class="custom-12px-400s font-color-98A2B3">Step 1</h3>
                                                        <h3 class="custom-16px-500 font-color-#171717" style="text-align: left;">Update & Review</h3>
                                                        <h3 class="custom-12px-400 bg-E0EAFF font-color-003CC5">Completed</h3>
                                                    </CCol>
                                                    <CCol sm="12" class="mt-3">
                                                        <h3 class="custom-12px-400s font-color-98A2B3">Step 1</h3>
                                                        <h3 class="custom-16px-500 font-color-#171717" style="text-align: left;">Update & Review</h3>
                                                        <h3 class="custom-12px-400 bg-E0EAFF font-color-003CC5">Completed</h3>
                                                    </CCol>
                                                    <CCol sm="12" class="mt-3">
                                                        <h3 class="custom-12px-400s font-color-98A2B3">Step 1</h3>
                                                        <h3 class="custom-16px-500 font-color-#171717" style="text-align: left;">Update & Review</h3>
                                                        <h3 class="custom-12px-400 bg-E0EAFF font-color-003CC5">Completed</h3>
                                                    </CCol>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                    </CCol>
                                    <CCol sm="7">
                                        <h3 class="custom-16px-500 bg-FEF3F2 font-color-B42318">Grand Total Payment
                                            <span style="display: block; margin-top: 5px;">RM 1548.05</span>
                                        </h3>
                                        <h3 class="custom-16px-500 bg-E0EAFF font-color-003CC5">Pay Satutory & Salary</h3>
                                        <CRow>
                                            <CCol sm="12">
                                                <h3 class="custom-14px-500 font-color-171717">Select Bank</h3>
                                                <v-select type="text" v-model="ShortName" />
                                            </CCol>
                                            <CCol sm="12" class="mt-3">
                                                <h3 class="custom-14px-500 font-color-171717">Bank File Available</h3>
                                                <CButton class="btn-border-blue font-color-0B63F6 w-100">CIMB BizChannel</CButton>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
        <div v-if="OpenDelete" class="popup-all backdrop-all">
            <div class="popup-all3">
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="12" class="text-center">
                                        <img :src="require('@/assets/img/delete.png')" alt="View" style="cursor: pointer; width:20%" @click="openDelete(row.Index)" class="ml-2" />
                                    </CCol>
                                    <CCol sm="12" class="text-center">
                                        <h3 class="custom-14px-500 font-color-171717">Are you sure?</h3>
                                    </CCol>
                                    <CCol sm="12" class="text-center">
                                        <h3 class="custom-14px-500 font-color-171717">Are you sure to delete this announcement?</h3>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <CRow>
                            <div class="text-right ml-2">
                            <CButton class="p-2 text-center bg-#FFFFF text-blue border-radius-half custom-button-padding" style="border-color: blue;" @click="SubmitCompany">
                                Delete</CButton>
                        </div>
                        <div class="text-left ml-5">
                             <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="closePopupDelete">
                                    Cancel</CButton>
                        </div>
                        </CRow>
                        
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import { CTextarea } from "@coreui/vue";


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            activeButton: 'paymentVoucherList', // Default active button
            buttons: [
                { value: 'paymentVoucherList', label: 'Payment Voucher List'},
                { value: 'task', label: 'Task'},
                { value: 'report', label: 'Report' },
            ],
            columns: [
                'No',
                'Payment Voucher No',
                'Year',
                'Month',
                'Payroll Date',
                'Status',
                'Remarks',
                'Action'
            ],
            allTableData: [
                { No: 1, 'Payment Voucher No': 'PV001', 'Year': '2024', Month: 'August', 'Payroll Date': '14 May 2024', Status: 'Closed', Remarks: '' },
                { No: 2, 'Payment Voucher No': 'PV002', 'Year': '2023', Month: 'November', 'Payroll Date': '14 July 2023', Status: 'Closed', Remarks: ''  },
                { No: 3, 'Payment Voucher No': 'PV003', 'Year': '2023', Month: 'January', 'Payroll Date': '14 January 2023', Status: 'Closed', Remarks: ''  }
            ], // Data for the leave table
            unreadTableData: [
                { No: 1, 'Payment Voucher No': 'Tambahan Elaun Parking Time', 'Year': 'New', Month: 'Muhammad Raziq Rashid', 'Payroll Date': '14 May 2024', Status: '14 May 2024', Remarks: '14 May 2024'  },
                { No: 2, 'Payment Voucher No': 'Perubahan Tetapan ‘ Auto Clock Out’', 'Year': 'New', Month: 'Muhammad Raziq Rashid', 'Payroll Date': '14 May 2024', Status: '14 May 2024', Remarks: '14 May 2024'  },
                { No: 3, 'Payment Voucher No': 'Cuti Tahunan (Annual Leave)', 'Year': 'New', Month: 'Muhammad Raziq Rashid', 'Payroll Date': '14 May 2024', Status: '14 May 2024', Remarks: '14 May 2024'  }
            ], // Data for the leave table
            options: {
                perPage: 5,
                pagination: true,
                searchable: true
            },
            isPopupSuccess: false,
            OpenCreate: false,
            OpenEdit: false,
            OpenDelete: false,


        }





    },
    async mounted() {
        //     try {
        //         const isAuth = await this.UserAuth();
        //         if (isAuth) {

        //         } else {
        //             this.GoToPage();
        //             this.$nextTick(() => {
        //   this.setCalendarView();
        // });
        //         }
        //     } catch (error) {
        //         this.GoToPage();
        //         console.error("Error during authentication:", error);
        //         // Handle the error here
        //     }

    },

    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },
        openCreate() {
            this.OpenCreate = true;
        },
        closeSuccess() {
            this.isPopupSuccess = false;
            this.OpenCreate = false;
        },
        closePopupCreate() {
            this.OpenCreate = false;
        },
        openEdit() {
            this.OpenEdit = true;
        },
        closePopupEdit() {
            this.OpenEdit = false;
        },
        openDelete() {
            this.OpenDelete = true;
        },
        closePopupDelete() {
            this.OpenDelete = false;
        },

    }

};
</script>